import * as _ from "lodash";
import * as React from "react";
import Select, { components } from "react-select";

import * as Models from "../../../Models";
import * as Const from "../../../Constants";
import { OutotecIcons } from "../../General/Icons/";

interface FileTypeSelectProps {
    document: Models.DocumentLinkUpload;
    // serviceVisitReportFileTypes: Models.ServiceVisitReportFileType[];

    updateFileToReadySendState: (document: Models.DocumentLinkUpload) => void;
}

const FileTypeSelect: React.FC<FileTypeSelectProps> = (
    props: FileTypeSelectProps
) => {
    const {
        updateFileToReadySendState,
        document,
        // serviceVisitReportFileTypes,
    } = props;

    const updateDocumentType: (documentType: any) => void = (documentType) => {
        updateFileToReadySendState(
            _.merge({}, document, {
                metaData: { documentType: documentType.value },
            })
        );
    };

    return (
        <Select
            isSearchable={false}
            isClearable={false}
            // value={document.metaData.documentType}
            placeholder="Select"
            onChange={updateDocumentType.bind(this)}
            options={Const.SERVICE_VISIT_REPORT_FILE_TYPES}
            controlShouldRenderValue={true}
            components={{ DropdownIndicator: CustomDropdownIndicator }}
            styles={{
                dropdownIndicator: (base) => ({
                    ...base,
                    padding: 8,
                    svg: {
                        fill: "#009CD9",
                        width: 17,
                        height: 11,
                    },
                    cursor: "pointer",
                }),
                control: (styles, { isFocused }) => ({
                    ...styles,
                    borderColor: isFocused ? "lightgrey" : "lightgrey", // Remove blue border on focus
                    boxShadow: "none", // Remove any box shadow (blue highlight)
                    ":hover": {
                        borderColor: "lightgrey",
                    },
                    minHeight: 35,
                }),
                placeholder: (styles) => ({
                    ...styles,
                    fontStyle: "italic",
                    color: "#ccc",
                }),
            }}
        />
    );
};

const CustomDropdownIndicator = (props) => {
    const isMenuOpen = props.selectProps.menuIsOpen;

    return (
        <components.DropdownIndicator {...props}>
            {isMenuOpen ? (
                <OutotecIcons type={Const.CHEVRON_UP} />
            ) : (
                <OutotecIcons type={Const.CHEVRON_DOWN} />
            )}
        </components.DropdownIndicator>
    );
};

export default FileTypeSelect;
